// The ONE door for a Twetch message signature from the connected wallet.
//
// `Wallet.provider.signMessage` is NOT that door. For the built-in Ordinals
// Wallet, `Wallet.provider` is the Wallet class itself, and its static
// `signMessage` answers `{ signature, success }` — the shape the /wallet sign
// page wants. Every extension provider answers a bare string. Sending that
// object to Twetch as `aip.signature` (or a login / profile `signature`) made
// the API reject the JSON body with HTTP 422 before it read a single field,
// so the built-in wallet could never post, like, follow, sign in or edit a
// profile on Social.
//
// `Wallet.signMessage` already speaks both dialects; this wraps it and turns
// the outcome into the string every Twetch signer expects, or throws a message
// the composer's rejection matcher recognises.

import Wallet from '@/utils/wallet'

export async function signMessageWithWallet(text: string): Promise<string> {
	const result: unknown = await Wallet.signMessage(text)
	return walletSignatureString(result)
}

/// What a wallet answered, normalised to the signature string Twetch verifies.
/// Accepts a bare string (extension providers) or `{ signature, success }`
/// (the built-in wallet); anything else is a refusal, never a payload.
export function walletSignatureString(result: unknown): string {
	if (typeof result === 'string') {
		if (result.trim()) return result
		throw new Error('The wallet did not sign. Try again.')
	}
	if (result && typeof result === 'object') {
		const r = result as { success?: boolean; signature?: unknown }
		if (r.success === false) throw new Error('You cancelled in the wallet. Nothing was sent.')
		if (typeof r.signature === 'string' && r.signature.trim()) return r.signature
	}
	throw new Error('The wallet did not sign. Try again.')
}
